module.exports = __webpack_public_path__ + "img/ic_empty_image.394f6c67.png";